import React from "react";
import { Translation } from "react-i18next";
import i18n from "../languages/lang.js";
function Home() {
  return (
    <Translation>
      {t => (
        <div id="main">
          <div id="header"></div>
          <div id="wrap">
            <div id="focus">
              <h1>{t("home.welcome")}</h1>
            </div>
          </div>
        </div>
      )}
    </Translation>
  );
}

export default Home;
